export default "__VITE_ASSET__VQ5QzwPm__"